/*
 * VRéserve custom-section videos (How to use, Product story, Benefits
 * spotlight): muted, looping, no visible controls. Tapping or clicking the
 * video pauses/plays it, and it doesn't autoplay for visitors who ask for
 * reduced motion. Horizon's own media videos use the theme's built-in
 * tap-to-pause instead.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (video) => {
    if (video.dataset.vrTapReady) return;
    video.dataset.vrTapReady = 'true';
    video.muted = true;
    video.setAttribute('muted', '');
    video.removeAttribute('controls');
    video.style.cursor = 'pointer';
    if (reduceMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
  };

  const scan = () => document.querySelectorAll('video.vr-tap-video').forEach(setup);

  document.addEventListener('click', (event) => {
    const video = event.target instanceof Element ? event.target.closest('video.vr-tap-video') : null;
    if (!video) return;
    if (video.paused) {
      video.dataset.userPaused = 'false';
      video.play().catch(() => {});
    } else {
      video.dataset.userPaused = 'true';
      video.pause();
    }
  });

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
